export enum StorageProperties {
  Session = 'session',
  SessionJwt = 'session_jwt',
  SessionUser = 'session_user',
  Theme = 'theme',
  CurrentProjectId = 'current_project_id',
  SaveQueue = 'save_queue',
  /** The admin's own session JWT, stashed here while impersonating another user so "Exit" can
   *  restore it. Presence of this key is also what ImpersonationBanner checks to know whether
   *  the current session is an impersonated one. */
  ImpersonatorJwt = 'impersonator_jwt',
}
